export interface SignUpFormValues {
    firstname: string;
    lastname: string;
    email: string;
    password: string;
    confirmPassword: string;
}

export type SignUpValidationError = "requiredFields" | "passwordMismatch" | "terms";

type SignUpCredentials = Omit<SignUpFormValues, "confirmPassword">;

export const submitSignUp = async (
    values: SignUpFormValues,
    hasAcceptedTerms: boolean,
    submit: (credentials: SignUpCredentials) => Promise<void>,
): Promise<SignUpValidationError | null> => {
    if (!values.firstname || !values.lastname || !values.email || !values.password || !values.confirmPassword) {
        return "requiredFields";
    }

    if (values.password !== values.confirmPassword) {
        return "passwordMismatch";
    }

    if (!hasAcceptedTerms) {
        return "terms";
    }

    await submit({
        firstname: values.firstname,
        lastname: values.lastname,
        email: values.email,
        password: values.password,
    });
    return null;
};
